import getTenant from "./getTenant";

const baseUrl = process.env.REACT_APP_CALLER_BASE_URL!;
const useTenantSubdomain = ["true", "1"].includes(
  process.env.REACT_APP_CALLER_USE_TENANT_SUBDOMAIN!.toLowerCase()
);

export default function getCallerURL({
  queryParams = {}
}: { queryParams?: { [k: string]: string } } = {}): string {
  const url = new URL(baseUrl);
  if (useTenantSubdomain) {
    url.host = `${getTenant()}.${url.host}`;
  }

  for (const [k, v] of Object.entries(queryParams)) {
    url.searchParams.set(k, v);
  }

  return url.toString();
}
